import { useSinglePrismicDocument } from '@prismicio/react';

function usePartners() {
  const [document, { state }] = useSinglePrismicDocument('partners');

  return state === 'loaded' ? document.data.partenaires : [];
}

export default usePartners;
